import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { AdminShell, adminPage } from '#/components/admin/admin-shell'
import { PromptEditor } from '#/components/admin/prompt-editor'
import { Badge } from '#/components/ui/badge'
import { useAdminPrompts } from '#/lib/api-admin'
import { fmtDate } from '#/lib/format'
import { cn } from '#/lib/utils'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/prompts')({ component: adminPage(Page) })

function Page() {
  const { data } = useAdminPrompts()
  const [key, setKey] = useState<string | null>(null)
  const prompts = data?.prompts ?? []
  const current = prompts.find((p) => p.key === key) ?? prompts[0]
  return (
    <AdminShell title={m.admin_nav_prompts()} description={m.admin_prompts_desc()} wide>
      <div className="grid gap-4 lg:grid-cols-[300px_1fr]">
        <div className="overflow-hidden rounded-xl border bg-card">
          <ul className="divide-y">
            {prompts.map((p) => (
              <li key={p.key}>
                <button type="button" onClick={() => setKey(p.key)} className={cn('flex w-full flex-col gap-0.5 px-3 py-2.5 text-left hover:bg-accent/40', current?.key === p.key && 'bg-accent text-accent-foreground')}>
                  <span className="flex items-center gap-2 text-sm font-medium">
                    {p.label}
                    {p.isModified ? <span className="size-2 rounded-full bg-status-progress" title={m.admin_prompt_modified()} /> : null}
                  </span>
                  <span className="flex items-center gap-2 text-xs text-muted-foreground">
                    <code>{p.key}</code>
                    <Badge variant="outline" className="h-4 px-1 text-[10px]">v{p.version}</Badge>
                    <span className="ml-auto">{fmtDate(p.updatedAt)}</span>
                  </span>
                </button>
              </li>
            ))}
            {!prompts.length ? <li className="px-3 py-6 text-center text-sm text-muted-foreground">{m.common_loading()}</li> : null}
          </ul>
        </div>
        <div className="rounded-xl border bg-card p-4">{current ? <PromptEditor key={current.key} prompt={current} /> : null}</div>
      </div>
    </AdminShell>
  )
}
